import { number } from "yup";

export const header: { id: number; label: string }[] = [
  {
    id: 0,
    label: "ID",
  },
  {
    id: 1,
    label: "Заголовок",
  },
  {
    id: 2,
    label: "Описание",
  },
  // {
  //   id: 3,
  //   label: "Изображение",
  // },
  {
    id: 4,
    label: "Получатели",
  },
];

export const formatRequest = (data) => {
  return data.length ? data.map((el) => el.value) : null;
};

export const validate = (values, radioValue) => {
  const errors: any = {};
  if (!values.title) {
    errors.title = "Обязательное поле";
  }
  if (!values.reciever.all && !values.reciever[radioValue].length) {
    errors.reciever = { [radioValue]: "Обязательное поле" };
  }
  return errors;
};
